module.exports = __webpack_public_path__ + "img/img121.3c0c2a6f.png";